<template>
  <div class="d-flex justify-center" :style="{ padding: '10px' }">
    <v-card
      class="d-flex pa-2 flex-column align-center justify-center"
      outlined
      :style="{
        'margin-bottom': '40px',
        width: '80%',
        'min-height': '550px',
        height: 'fit-content',
      }"
      elevation="2"
    >
      <h3 class="ma-2 text-center">Bulk Upload - {{ uploadType }}</h3>
      <div
        class="d-flex flex-row justify-center align-center flex-wrap"
        :style="{
          'text-align': 'center',
          width: '70%',
          padding: '50px 0px 50px 0px',
        }"
      >
        <div
          class="d-flex flex-column justify-center align-center"
          style="flex: 1"
          v-if="isUpdate"
        >
          <v-row align="center" class="ma-2" style="width: 80%" v-if="isUpdate">
            <v-autocomplete
              v-model="selectedMerchants"
              :items="filteredMerchants"
              persistent-hint
              label="Merchant"
              placeholder="select merchant"
              multiple
              outlined
              prepend-inner-icon="mdi-store"
              return-object
              :item-text="item => `${item.merchant_name} - ${item.mid}`"
              item-key="mid"
              :loading="loadingMerchant"
              :search-input.sync="searchMerchant"
              :error-messages="selectedMerchantsErrors"
            >
              <v-list-item slot="prepend-item" ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="
                      selectedMerchants.length > 0 ? 'indigo darken-4' : ''
                    "
                    >{{ icon }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item>
              <v-divider slot="prepend-item" class="mt-2" />
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index == 0">
                  <span>{{ item.merchant_name }} - {{ item.mid }}</span>
                </v-chip>
                <span v-if="index == 1" class="grey--text caption">
                  (+{{ selectedMerchants.length - 1 }} others)
                </span>
              </template>
              <template v-slot:item="{ item }">
                <span>{{ item.merchant_name }} - {{ item.mid }}</span>
              </template>
            </v-autocomplete>
          </v-row>
          <v-row class="mb-4 mt-1">
            <v-btn
              v-if="isUpdate"
              small
              @click="getDownloadFile"
              :loading="loadingDownloadFile"
              :disabled="loadingDownloadFile"
            >
              Download Template
            </v-btn>
          </v-row>
        </div>
        <div
          class="d-flex flex-column justify-center align-center"
          style="flex: 1"
        >
          <v-row align="center" class="ma-2" style="width: 60%">
            <v-file-input
              label="Data Merchant (.xlsx)"
              placeholder="Select your files"
              :accept="validate.file_bulk_aggregator.type.join()"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-paperclip"
              prepend-icon=""
              v-model="fileBulkMerchant"
              @click="clearLastResult()"
              @focus="fileBulkMerchantFocus += 1"
              :error-messages="fileBulkMerchantErrors"
              @change="$v.fileBulkMerchant.$touch()"
              @blur="$v.fileBulkMerchant.$touch()"
            />
          </v-row>
          <v-row v-if="onUpload" style="width: 60%" class="mb-5">
            <h4>Uploading..</h4>
            <v-progress-linear
              v-model="uploadProgress"
              :active="onUpload"
              :query="true"
            />
          </v-row>
          <v-row v-if="onInsert" style="width: 60%" class="mb-5">
            <h4>{{ insertName }}</h4>
            <v-progress-linear
              v-model="insertProgress"
              :active="onInsert"
              :query="true"
            />
          </v-row>
          <v-row v-if="loadingStatus" style="width: 60%" class="mb-5">
            <h4>Generating download file..</h4>
            <v-progress-linear :indeterminate="loadingStatus" />
          </v-row>
          <v-row
            class="d-flex flex-column justify-center mb-5"
            v-if="hasFailedImport"
            style="width: 60%"
          >
            <v-card
              class="d-flex flex-column text-left pa-5"
              style="font-size: 13px"
            >
              <h3>Last result :</h3>
              <div style="color: green">
                {{ countSuccess }} record berhasil !
              </div>
              <div style="color: red; margin-bottom: 10px">
                {{ countFailed }} record gagal !
              </div>
              <div class="text--primary">
                Klik
                <a
                  v-if="!loadingDownloadFailed"
                  @click="downloadFailed"
                  @keydown.enter="downloadFailed"
                  >Download</a
                >
                <span v-else>Downloading...</span>
                untuk mengunduh data yang gagal kedalam file .xls
              </div>
            </v-card>
          </v-row>
          <v-row class="mb-1" v-if="!isUpdate">
            <v-btn
              small
              :loading="loadingDownloadTemplate"
              :disabled="loadingDownloadTemplate"
              @click="downloadBaseTemplate"
            >
              Download Template
            </v-btn>
          </v-row>
          <v-row align="center" class="mb-4 mt-1">
            <v-btn
              small
              color="success"
              :disabled="onUpload || onInsert || isUploadDisabled"
              :loading="onUpload || onInsert"
              @click="upload"
              :style="{ margin: '2px' }"
            >
              Upload
            </v-btn>
            <v-btn
              small
              color="warning"
              :disabled="onUpload"
              @click="back"
              :style="{ margin: '2px' }"
            >
              Kembali
            </v-btn>
          </v-row>
        </div>
      </div>

      <template v-if="!isUpdate">
        <p class="text-justify text-caption">
          Note:<br />
          To register a merchant, please use an email that has not been
          registered in the system.<br />
          To register outlets, please use a registered merchant's email.<br/>
          Maximum row must be 1000 rows and maximum file size must be 5 MB.
        </p>
      </template>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { validations } from '../../../store/params';
import { date, showAlert } from '../../../lib/helpers';

export default {
  name: 'step2',
  mixins: [validationMixin],
  validations: {
    selectedMerchants: {
      required() {
        return this.selectedMerchants.length >= 1;
      },
    },
    fileBulkMerchant: {
      required() {
        if (this.fileBulkMerchantFocus > 1) {
          return this.fileBulkMerchant != null;
        }
        return true;
      },
      fileType() {
        if (this.fileBulkMerchant != null) {
          return !!validations.file_bulk_aggregator.type.includes(
            this.fileBulkMerchant.type.toLowerCase()
          );
        }
        return true;
      },
      fileSize() {
        if (this.fileBulkMerchant != null) {

          return this.fileBulkMerchant.size <= 5 * 1024 * 1024;
        }

        return true;
      }
    },
  },
  mounted() {
    this.$store.commit('inputer/aggregator/clearLastResult');
    // Load initial merchant list
    this.getListMerchant();
  },
  watch: {
    searchMerchant: {
      handler(newVal) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.getListMerchant(newVal);
        }, 500);
      },
    },
    selectedMerchants: {
      handler() {
        this.searchMerchant = '';
      },
    },
  },
  data() {
    return {
      validate: validations,
      fileBulkMerchant: null,
      loadingDownloadTemplate: false,
      loadingDownloadFailed: false,
      fileBulkMerchantFocus: 0,
      merchants: [],
      allMerchants: [],
      selectedMerchants: [],
      searchMerchant: '',
      loadingDownloadFile: false,
      searchTimeout: null,
    };
  },
  beforeCreate() {
    if (
      this.$route.params.id === 'add-sub' ||
      this.$route.params.id === 'update-sub-pten' ||
      this.$route.params.id === 'update-sub-non-pten' ||
      this.$route.params.id === 'block-unblock'
    ) {
      return true;
    }
    this.$router.back();
    return false;
  },
  computed: {
    filteredMerchants() {
      return this.allMerchants;
    },
    isUploadDisabled() {
      return this.fileBulkMerchantErrors.length > 0;
    },
    uploadType() {
      let type = '';
      if (this.$route.params.id === 'add-sub') type = 'Add Sub Merchant';
      else if (this.$route.params.id === 'update-sub-pten') {
        type = 'Update Sub Merchant PTEN';
      } else if (this.$route.params.id === 'update-sub-non-pten') {
        type = 'Update Sub Merchant Non PTEN';
      } else if (this.$route.params.id === 'block-unblock') {
        type = 'Block/Unblock Sub Merchant';
      }
      return type;
    },
    isUpdate() {
      return (
        this.$route.params.id === 'update-sub-pten' ||
        this.$route.params.id === 'update-sub-non-pten' ||
        this.$route.params.id === 'block-unblock'
      );
    },
    isPTEN() {
      let ptenVal;

      if (this.$route.params.id === 'update-sub-pten') {
        ptenVal = 1;
      }
      if (this.$route.params.id === 'update-sub-non-pten') {
        ptenVal = 2;
      }
      if (this.$route.params.id === 'block-unblock') {
        ptenVal = 3;
      }
      return ptenVal;
    },
    loading() {
      return this.$store.state.inputer.aggregator.loading;
    },
    loadingMerchant() {
      return this.$store.state.inputer.merchant.loadingListMerchant;
    },
    loadingStatus() {
      return this.$store.state.inputer.aggregator.loadingStatus;
    },
    uploadProgress() {
      return this.$store.state.inputer.aggregator.uploadProgress;
    },
    uploadName() {
      return this.$store.state.inputer.aggregator.uploadName;
    },
    onUpload() {
      return this.$store.state.inputer.aggregator.onUpload;
    },
    insertProgress() {
      return this.$store.state.inputer.aggregator.insertProgress;
    },
    insertName() {
      return this.$store.state.inputer.aggregator.insertName;
    },
    onInsert() {
      return this.$store.state.inputer.aggregator.onInsert;
    },
    countSuccess() {
      return this.$store.state.inputer.aggregator.countSuccess;
    },
    countFailed() {
      return this.$store.state.inputer.aggregator.countFailed;
    },
    hasFailedImport() {
      return this.$store.state.inputer.aggregator.hasFailedImport;
    },
    fileBulkMerchantErrors() {
      const errors = [];
      if (!this.$v.fileBulkMerchant.$dirty) return errors;
      if (!this.$v.fileBulkMerchant.required)
        errors.push('File Merchant is required');
      if (!this.$v.fileBulkMerchant.fileType)
        errors.push('Incorrect filetype Merchant File');
      if (!this.$v.fileBulkMerchant.fileSize)
        errors.push('Error file! Maximum file size must be 5 MB');

      return errors;
    },
    selectedMerchantsErrors() {
      const errors = [];
      if (!this.$v.selectedMerchants.$dirty) return errors;
      if (!this.$v.selectedMerchants.required)
        errors.push('Merchant is required for template');
      return errors;
    },
    selectAllMerchant() {
      const idMerchants = this.filteredMerchants.map((val) => val.id);
      const selectedIdMerchant = this.selectedMerchants.map((val) => val.id);
      return (
        idMerchants.filter((x) => selectedIdMerchant.includes(x)).length ===
        this.filteredMerchants.length && this.filteredMerchants.length > 0
      );
    },
    selectSomeMerchant() {
      return this.selectedMerchants.length > 0 && !this.selectAllMerchant;
    },
    icon() {
      if (this.selectAllMerchant) return 'mdi-close-box';
      if (this.selectSomeMerchant) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  methods: {
    async downloadFailed() {
      this.loadingDownloadFailed = true;
      try {
        const response = await this.$store.dispatch(
          'inputer/aggregator/downloadFailedImport'
        );
        if (response) {
          this.saveBlobResponse(response, `failed-import-${this.$route.params.id}.xlsx`);
        }
      } finally {
        this.loadingDownloadFailed = false;
      }
    },
    async downloadBaseTemplate() {
      this.loadingDownloadTemplate = true;
      try {
        const response = await this.$store.dispatch(
          'inputer/aggregator/downloadTemplate'
        );
        if (response) {
          this.saveBlobResponse(response, `template-${this.$route.params.id}.xlsx`);
        }
      } finally {
        this.loadingDownloadTemplate = false;
      }
    },
    saveBlobResponse(response, fallbackName) {
      const blob = new Blob([response.data]);
      const fileUrl = URL.createObjectURL(blob);
      const contentDisposition = response.headers['content-disposition'] || '';
      const fileNameMatch = contentDisposition.match(
        /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i
      );
      const fileName = fileNameMatch
        ? decodeURIComponent(fileNameMatch[1])
        : fallbackName;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileUrl);
    },
    back() {
      this.$router.push('/inputer/aggregator');
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllMerchant) {
          this.selectedMerchants = [];
        } else {
          const selectedIdMerchant = this.selectedMerchants.map(
            (val) => val.id
          );
          const diff = this.filteredMerchants.filter(
            (x) => !selectedIdMerchant.includes(x.id)
          );
          this.selectedMerchants = this.selectedMerchants.concat(diff);
        }
      });
    },
    getListMerchant() {
      this.$store
        .dispatch('inputer/merchant/getListMerchant', {
          searchMerchant: { merchant_name: this.searchMerchant },
          aggregatorId: this.$route.params.idAggregator,
          date,
        })
        .then((response) => {
          if (response) {
            this.allMerchants = response.list;
            this.selectedMerchants.forEach((selected) => {
              const exists = this.allMerchants.some(m => m.id === selected.id);
              if (!exists) {
                this.allMerchants.push(selected);
              }
            });
            this.merchants = this.allMerchants;
          }
        });
    },
    async getDownloadFile() {
      const ids = this.selectedMerchants.map((merchant) => merchant.id);
      this.$v.selectedMerchants.$touch();

      if (this.$v.selectedMerchants.$error) {
        return;
      }
      if (ids.length === 0) {
        showAlert(
          this.$store,
          'Merchant must be selected !',
          'mdi-alert',
          'red'
        );
        return;
      }

      this.loadingDownloadFile = true;
      try {
        const response = await this.$store.dispatch(
          'inputer/merchant/generateMerchant',
          {
            merchant_id: ids,
            type_pten: this.isPTEN, // ? "1" : "2",
            aggregator_id: this.$route.params.idAggregator,
            date,
          }
        );
        if (response) {
          this.saveBlobResponse(
            response,
            `sub-merchant-data-${this.$route.params.id}.xlsx`
          );
        }
      } finally {
        this.loadingDownloadFile = false;
      }
    },
    upload() {
      this.fileBulkMerchantFocus = 2;
      this.$v.fileBulkMerchant.$touch();
      if (!this.$v.fileBulkMerchant.$error) {
        if (this.$route.params.idAggregator !== undefined && this.isUpdate) {
          if (!Number.isNaN(parseInt(this.$route.params.idAggregator, 10))) {
            this.$store
              .dispatch('inputer/aggregator/bulkUploadSub', {
                file: this.fileBulkMerchant,
                action: this.$route.params.id,
                aggregator_id: this.$route.params.idAggregator,
                merchant_id: this.$route.params.idSubMerchant,
                type_pten: this.isPTEN, // ? "1" : "2",
                type_merchant: '4',
                date,
              })
              .then(() => {});
          }
        } else if (
          this.$route.params.idAggregator !== undefined &&
          !this.isUpdate
        ) {
          if (!Number.isNaN(parseInt(this.$route.params.idAggregator, 10))) {
            this.$store
              .dispatch('inputer/aggregator/bulkUploadSub', {
                file: this.fileBulkMerchant,
                action: this.$route.params.id,
                aggregator_id: this.$route.params.idAggregator,
                merchant_id: null,
                date,
              })
              .then(() => {});
          }
        }
      }
    },
    clearLastResult() {
      this.$store.commit('inputer/aggregator/clearLastResult');
    },
  },
};
</script>
